/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { CAN_USE_DOM } from "./canUseDOM";




// Check if documentMode exists and can be used safely
const documentMode =
  CAN_USE_DOM && 'documentMode' in document ? document.documentMode : null;

// Check if the current platform is Apple (Mac, iPod, iPhone, iPad)
export const IS_APPLE =
  CAN_USE_DOM && /Mac|iPod|iPhone|iPad/.test(navigator.platform);

// Check if the current browser is Firefox (not SeaMonkey)
export const IS_FIREFOX =
  CAN_USE_DOM && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);

// Check if 'InputEvent' is available in window and supports 'getTargetRanges'
export const CAN_USE_BEFORE_INPUT =
  CAN_USE_DOM &&
  'InputEvent' in window &&
  !documentMode &&
  'getTargetRanges' in new window.InputEvent('input');

// Check if the current browser is Safari
export const IS_SAFARI =
  CAN_USE_DOM && /Version\/[\d.]+.*Safari/.test(navigator.userAgent);

// Check if the current platform is iOS (iPad, iPhone, iPod) and not using MSStream
export const IS_IOS =
  CAN_USE_DOM &&
  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  !window.MSStream;

// Check if the current platform is Android
export const IS_ANDROID =
  CAN_USE_DOM && /Android/.test(navigator.userAgent);

// Check if the current browser is Chrome
export const IS_CHROME =
  CAN_USE_DOM && /^(?=.*Chrome).*/i.test(navigator.userAgent);

// Check if the current platform is Android and the browser is Chrome
export const IS_ANDROID_CHROME =
  CAN_USE_DOM && IS_ANDROID && IS_CHROME;

// Check if the current browser uses Apple WebKit engine and is not Chrome
export const IS_APPLE_WEBKIT =
  CAN_USE_DOM &&
  /AppleWebKit\/[\d.]+/.test(navigator.userAgent) &&
  !IS_CHROME;
